const getItem = (item, getter) => {
    if (!getter)
        return { text: '' };
    if (typeof getter === 'string') {
        const text = item[getter] || '-';
        return { text };
    }
    if (typeof getter === 'function') {
        try {
            const result = getter(item);
            if (typeof result === 'string') {
                return { text: result };
            }
            return result;
        }
        catch (error) {
            return { text: '' };
        }
    }
};
const getItemColumns = (item, columns) => {
    return columns.map(({ getter, ...column }) => {
        const parsedItem = getItem(item, getter);
        return { ...column, ...parsedItem, _hash: item._hash };
    });
};
const randomHash = () => Math.random().toString(36).substring(2);
const addHash = (arr = []) => {
    return arr.map(a => (a._hash ? a : { ...a, _hash: randomHash() }));
};
const getSortableValue = (item, sort) => {
    if (!sort)
        return undefined;
    if (typeof sort === 'string')
        return item[sort];
    if (typeof sort === 'function') {
        try {
            return sort(item);
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    return undefined;
};
const getSortableFilter = (active, orderByAsc, sort) => {
    if (!active || !sort)
        return null;
    return (rows) => {
        return [...rows].sort((rowA, rowB) => {
            const valueA = getSortableValue(rowA, sort);
            const valueB = getSortableValue(rowB, sort);
            return orderByAsc
                ? sortableFilter(valueA, valueB)
                : sortableFilter(valueB, valueA);
        });
    };
};
const sortableFilter = (valueA, valueB) => {
    if (typeof valueA === 'string' && typeof valueB === 'string') {
        return valueA.localeCompare(valueB);
    }
    if (typeof valueA === 'number' && typeof valueB === 'number') {
        return valueA > valueB ? 1 : -1;
    }
    if (valueA instanceof Date && valueB instanceof Date) {
        return valueA.getTime() - valueB.getTime();
    }
    return 0;
};

export { addHash, getItem, getItemColumns, getSortableFilter };
//# sourceMappingURL=DataTableHelpers.js.map
